module.exports = __webpack_public_path__ + "img/playstore.61454b13.png";